export default {
    "Стартовый отчет": "start",
    "Стандартный отчет": "standard",
    "Полный отчет": "full",
    "Для исследований": "empty"
}